import { Component, TemplateFunction } from '@ribajs/core'
import { hasChildNodesTrim } from '@ribajs/utils'
import { toasterService } from '../services'

interface Scope {
  success: typeof toasterService.success
  info: typeof toasterService.info
  warning: typeof toasterService.warning
  danger: typeof toasterService.danger
}

/**
 * Simple preview component for the sb-toaster component used in the styleguide
 */
export class SbToasterPreviewComponent extends Component {
  public static tagName = 'sb-toaster-preview'

  public scope: Scope = {
    success: toasterService.success.bind(toasterService),
    info: toasterService.info.bind(toasterService),
    warning: toasterService.warning.bind(toasterService),
    danger: toasterService.danger.bind(toasterService),
  }

  /**
   * Called as soon as this custom element es detected in the dom
   */
  protected connectedCallback() {
    super.connectedCallback()
    this.init([])
  }

  protected template(): ReturnType<TemplateFunction> {
    if (!hasChildNodesTrim(this)) {
      return (
        <p class="error">
          This component has no it's own template, you need to add your own
          child HTML
        </p>
      )
    }
    return null
  }
}
